import React, { useState,useEffect } from "react";
import { FaSave } from "react-icons/fa";
import { AiOutlineDownload } from "react-icons/ai";

const RegistrationFormComponent = ({ registrationForm, setRegistrationForm,handleDownload }) => {
    
   
  if (!registrationForm) return <p>Loading...</p>;

  
  const handleChange = (e, field, nestedField = null) => {
    const { value } = e.target;
  };
  
  
  let abc=['3. ','',''];

  return (
    <div className="w-full max-w-4xl mx-auto p-1 bg-white shadow-md rounded-md text-sm">
      
      {/* Student Details */}
      <div className="flex flex-col gap-4 ">

        {
          (<div className="bg-purple-100 p-2">
                <label><span></span>Form Number</label>
                <p className="font-semibold">
                    {registrationForm.form_number}
                </p>
              </div>)
        }

        <div className="bg-green-100 p-2">
          <label><span>1.</span>Student Name *</label>
          <input
            type="text"
            value={registrationForm.student_name || ""}
            onChange={(e) => handleChange(e, "student_name")}            
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}
          />
        </div>

<div className="flex flex-col gap-4  bg-purple-100 p-2">
        <div>
          <label><span>2.</span>Date of Birth*</label>
          <input
            type="date"
            value={registrationForm.dob || ""}
            onChange={(e) => handleChange(e, "dob")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          />
        </div>

        <div>
          <label><span></span>Age*</label>
          <p>{registrationForm.age || ""}</p>
        </div>

        <div>
            <label><span>  </span>Registration for Class*</label>
            <select
                value={registrationForm.registration_for_class || ""}
                onChange={(e) => handleChange(e, "registration_for_class")}
               

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            >
                <option value="">Select Class</option>
                {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                    {i + 1}
                </option>
                ))}
            </select>
            </div>


            <div>
                <label><span></span>Religion*</label>
                <select
                    value={registrationForm.religion || ""}
                    onChange={(e) => handleChange(e, "religion")}
                   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



                >
                    <option value="">Please select</option>
                    <option value="Hinduism">Hinduism</option>
                    <option value="Islam">Islam</option>
                    <option value="Christianity">Christianity</option>
                    <option value="Sikhism">Sikhism</option>
                    <option value="Buddhism">Buddhism</option>
                    <option value="Jainism">Jainism</option>
                    <option value="Other">Other</option>
                </select>
                </div>

               {registrationForm.religion === "Other" && (
                <div>
                    <label>Other Religion</label>
                    <input
                    type="text"
                    value={registrationForm.religion_other || ""}
                    onChange={(e) => handleChange(e, "religion_other")}
                   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



                    />
                </div>
                )}

                <div>
                <label><span></span>Gender*</label>
                <select
                    value={registrationForm.gender || ""}
                    onChange={(e) => handleChange(e, "gender")}
                   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



                >
                    <option value="">Please select</option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                    <option value="Other">Other</option>
                </select>
                </div>

                <div>
                <label><span></span>Caste*</label>
                <select
                    value={registrationForm.caste || ""}
                    onChange={(e) => handleChange(e, "caste")}
                   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



                >
                    <option value="">Please select</option>
                    <option value="General">General</option>
                    <option value="Scheduled Caste (SC)">Scheduled Caste (SC)</option>
                    <option value="Scheduled Tribe (ST)">Scheduled Tribe (ST)</option>
                    <option value="Other Backward Class (OBC)">Other Backward Class (OBC)</option>
                    <option value="Economically Weaker Section (EWS)">Economically Weaker Section (EWS)</option>
                    <option value="Other">Other</option>
                </select>
                </div>
                {registrationForm.caste === "Other" && (
                <div>
                    <label>Other Caste</label>
                    <input
                    type="text"
                    value={registrationForm.caste_other || ""}
                    onChange={(e) => handleChange(e, "caste_other")}
                   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



                    />
                </div>
                )}

                <div>
  <label><span></span>Last School Name</label>
  <input
    type="text"
    value={registrationForm.last_school_name || "NA"}
    onChange={(e) => handleChange(e, "last_school_name")}
   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



  />
</div>

<div>
  <label><span></span>Transfer Certificate No</label>
  <input
    type="text"
    value={registrationForm.transfer_certificate_no || "NA"}
    onChange={(e) => handleChange(e, "transfer_certificate_no")}
   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



  />
</div>

<div>
  <label><span></span>Transfer Date</label>
  <input
    type="date"
    value={registrationForm.transfer_date || ""}
    onChange={(e) => handleChange(e, "transfer_date")}
   

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



  />
</div>

<div>
  <label><span></span>Transfer Class</label>
            <select
                value={registrationForm.transfer_class || ""}
                onChange={(e) => handleChange(e, "transfer_class")}
               

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            >
                <option value="">Select Class</option>
                {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                    {i + 1}
                </option>
                ))}
            </select>
</div>

        <div>
          <label><span></span>PEN</label>
          <input
            type="text"
            value={registrationForm.PEN || ""}
            onChange={(e) => handleChange(e, "PEN")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          />
        </div>

        <div>
          <label><span></span>Specially Abled</label>
          <select
            value={registrationForm.specially_abled || "No"}
            onChange={(e) => handleChange(e, "specially_abled")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          >
            <option value="Yes">Yes</option>
            <option value="No">No</option>
          </select>
        </div>
        {registrationForm.specially_abled === "Yes" && (
  <div>
    <label>Specially Abled Details</label>
    <textarea
      value={registrationForm.specially_abled_details || ""}
      onChange={(e) => handleChange(e, "specially_abled_details")}
     

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



      rows={4} // Adjust the number of rows as needed
    />
  </div>
)}

        <div>
          <label><span></span>Student Health Issue</label>
          <textarea
            rows={4}
            value={registrationForm.student_health_issue || "None"}
            onChange={(e) => handleChange(e, "student_health_issue")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          />
        </div>
      

      <div>
        <label><span></span>Field of Interest</label>
        <select
            value={registrationForm.field_of_interest || ""}
            onChange={(e) => handleChange(e, "field_of_interest")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        >
            <option value="">Please select</option>
            <option value="Self defense and physical fitness training">
            Self defense and physical fitness training
            </option>
            <option value="Calligraphy - for beautiful handwriting">
            Calligraphy - for beautiful handwriting
            </option>
            <option value="Music">Music</option>
            <option value="Drawing">Drawing</option>
            <option value="Dance">Dance</option>
            <option value="Any Other">Any Other</option>
        </select>
        </div>
        {registrationForm.field_of_interest === "Any Other" && (
  <div>
    <label>Other Interests</label>
    <textarea
      value={registrationForm.field_of_interest_other || ""}
      onChange={(e) => handleChange(e, "field_of_interest_other")}
     

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



      rows={4} // Adjust the number of rows as needed
    />
  </div>
)}
        </div>
        </div>
      {/* Sibling Details */}
      
      {["sibling_0", "sibling_1", "sibling_2"].map((sibling, index) => (
        <div key={index} className="mt-4 flex flex-col gap-4 bg-green-100 p-2">
          <h3 ><span>{`${abc[index]}`}</span>{`School going Sibling-${index + 1}`}</h3>
          <div>
            <label>Name</label>
            <input
              type="text"
              value={registrationForm[sibling]?.name || ""}
              onChange={(e) => handleChange(e, sibling, "name")}
             

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            />
          </div>

          <div>
            <label>School</label>
            <input
              type="text"
              value={registrationForm[sibling]?.school || ""}
              onChange={(e) => handleChange(e, sibling, "school")}
             

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            />
          </div>

          <div>
            <label>Class</label>
            <select
                value={registrationForm[sibling]?.class || ""}
                onChange={(e) => handleChange(e, sibling, "class")}
               

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            >
                <option value="">Select Class</option>
                {Array.from({ length: 12 }, (_, i) => (
                <option key={i + 1} value={i + 1}>
                    {i + 1}
                </option>
                ))}
            </select>
            
           
          </div>
        </div>
      ))}

      {/* Parent Details */}
{["father", "mother"].map((parent, index) => (
    <div
  key={parent}
  className={`mt-4 flex flex-col gap-4 p-2 ${
    parent === "father" ? "bg-purple-100" : "bg-green-100"
  }`}
>

    <h3>
      <span>{4 + index}.</span> {parent.charAt(0).toUpperCase() + parent.slice(1)}'s Details (Complete information for at least one parent is mandatory.)
    </h3>
    {["name", "qualification", "annual_income", "occupation", "mobile_no", "email_id", "aadhar_no"].map((field) => (
      <div key={field}>
        <label>{parent+" "+field.replace("_", " ")}</label>

        {/* Select input for annual_income */}
        {field === "annual_income" ? (
          <select
            value={registrationForm[parent]?.[field] || ""}
            onChange={(e) => handleChange(e, parent, field)}
            
            
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          >
            <option value="">Select Annual Income</option>
            {[
              "less than 2 Lakh a year",
              "between 2-3 Lakh a year",
              "between 3-4 Lakh a year",
              "between 4-5 Lakh a year",
              "between 5-6 Lakh a year",
              "between 6-7 Lakh a year",
              "between 7-8 Lakh a year",
              "between 8-9 Lakh a year",
              "between 9-10 Lakh a year",
              "between 10-11 Lakh a year",
              "between 11-12 Lakh a year",
              "between 12-13 Lakh a year",
              "between 13-14 Lakh a year",
              "between 14-15 Lakh a year",
              "between 15-20 Lakh a year",
              "between 20-30 Lakh a year",
              "between 30-50 Lakh a year",
              "more than 50 Lakh a year",
            ].map((income) => (
              <option key={income} value={income}>
                {income}
              </option>
            ))}
          </select>
        ) : field === "occupation" ? (
          // Select input for occupation
          <select
            value={registrationForm[parent]?.[field] || ""}
            onChange={(e) => handleChange(e, parent, field)}
            
            
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          >
            <option value="">Select Occupation</option>
            {["Central", "State", "Private Sector", "Self Employed"].map((occupation) => (
              <option key={occupation} value={occupation}>
                {occupation}
              </option>
            ))}
          </select>
        ) : (
          // Default input for other fields
          <input
            type="text"
            value={registrationForm[parent]?.[field] || ""}
            onChange={(e) => handleChange(e, parent, field)}
            
            
  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



          />
        )}
      </div>
    ))}
  </div>
))}


<div className="mt-4 flex flex-col bg-purple-100 p-2">
        <label><span>6.</span>Hostel Need</label>
        <select
          value={registrationForm.hostel_need || "No"}
          onChange={(e) => handleChange(e, "hostel_need")}
         

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>

      {/* Guardian Details */}
      {registrationForm.hostel_need==='Yes' && (<div className="mt-4 flex flex-col gap-4 bg-purple-100 p-2">
        <h3 className="">Local Guardian (If Hostel is needed)</h3>
        {["name", "mobile_no", "email_id", "aadhar_no"].map((field) => (
          <div key={field}>
            <label>{"Local Guardian "+field.replace("_", " ")+"*"}</label>
            <input
              type="text"
              value={registrationForm.local_guardian?.[field] || ""}
              onChange={(e) => handleChange(e, "local_guardian", field)}
             

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



            />
          </div>
        ))}
      </div>)}

      {/* Additional Details */}
      <div className="mt-4 bg-green-100 p-2">
        <label><span>7.</span>Correspondence Address*</label>
        <textarea
        row="4"
          value={registrationForm.correspondence_address || ""}
          onChange={(e) => handleChange(e, "correspondence_address")}
         

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        />
      </div>

      <div className="mt-4 bg-purple-100 p-2">
        <label><span>8.</span>Permanent Address*</label>
        <textarea
          row="4"
          value={registrationForm.permanent_address || ""}
          onChange={(e) => handleChange(e, "permanent_address")}
         

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        />
      </div>

      <div className="mt-4 bg-green-100 p-2">
        <label><span>9.</span>Type of Payment*</label>
        <select
            value={registrationForm.type_of_payment || ""}
            onChange={(e) => handleChange(e, "type_of_payment")}
           

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        >
            <option value="">Please select</option>
            <option value="monthly">Monthly</option>
            <option value="quarterly">Quarterly</option>
            <option value="half yearly">Half Yearly</option>
            <option value="yearly">Yearly (One Time)</option>
        </select>
        </div>


      <div className="mt-4 bg-purple-100 p-2">
        <label><span>10.</span>Transportation Need</label>
        <select
          value={registrationForm.transportation_need || "No"}
          onChange={(e) => handleChange(e, "transportation_need")}
         

  className={`border-b-2 border-blue-500 p-2 w-full bg-transparent ${
    registrationForm.submission_status === "submitted" ? "" : ""
  }`}



        >
          <option value="Yes">Yes</option>
          <option value="No">No</option>
        </select>
      </div>
      

      
<div className="bg-gray-100 p-2 rounded-lg shadow-md w-full border border-gray-300 mt-3 flex flex-wrap justify-around ">




{true &&(<button
  onClick={handleDownload}
  className="flex items-center gap-2 px-4 py-2 text-white text-xs rounded-lg shadow-md transition duration-300 
             bg-orange-600 hover:bg-orange-700 m-1"
>
<AiOutlineDownload size={20} />
  DOWNLOAD PDF
</button>)}
</div>


    </div>
  );
};

export default RegistrationFormComponent;
